/**
 * @typedef {Object} ArticleOverviewGridTeaserModel
 * @property {HalfSizeTeaserModel|ErrorTeaserModel} teaser
 */

import {TrackingContextAppend} from '../TrackingContext.jsx';
import {useMemo} from 'react';
import {CfPreview} from '../CfPreviewContext.jsx';
import {HalfSizeTeaser} from './HalfSizeTeaser.jsx';
import {ErrorTeaser} from './ErrorTeaser.jsx';

/**
 * @param {ArticleOverviewTeaserContentModel} pageModel
 * @param {ArticleOverviewGridTeaserModel} teaserModel
 * @returns {JSX.Element}
 */
export function ArticleOverviewGridTeaser({pageModel, teaserModel}) {
    if (!pageModel || !teaserModel) return null;

    const landmark = useMemo(
        () =>
            pageModel.landmark
                ? {
                      cfEnvironment: pageModel.landmark.environment,
                      teaserPageEntryId: pageModel.landmark.entryId,
                  }
                : null,
        [pageModel.landmark?.environment, pageModel.landmark?.entryId],
    );

    return (
        <TrackingContextAppend value={landmark}>
            <CfPreview locale={pageModel.contentfulLocale} enabled={pageModel.enablePreview}>
                <Teaser model={teaserModel.teaser} device={pageModel.device} key={teaserModel.teaser.entryId} />
            </CfPreview>
        </TrackingContextAppend>
    );
}

/**
 * @param { HalfSizeTeaserModel | ErrorTeaserModel } model
 * @param {Device} device
 * @returns {JSX.Element}
 */
function Teaser({model, device}) {
    switch (model.type) {
        case 'HALF_SIZE_TEASER':
            return <HalfSizeTeaser model={model} device={device} />;
        case 'ERROR_TEASER':
            return <ErrorTeaser model={model} />;
        default:
            return null;
    }
}
